import { combineReducers } from 'redux';

import type { Reducer } from 'Lib/reduxType';

import {
  getCommonResetAction,
  STATE_ERROR,
  STATE_LOADING,
  STATE_SUCCESS,
} from 'Store/commonActions';
import { LOGIN_START, PERSIST_LINE_BUTTON } from 'Store/mfa/constants';
import { FETCH_PROFILE_SUCCESS } from 'Store/profile/constants';

import {
  RESET_LINE_TOKEN_STATE,
  SUBMIT_LINE_TOKEN,
  VALIDATE_LINE_TOKEN_ERROR,
  VALIDATE_LINE_TOKEN_SUCCESS,
} from './constants';
import initialState from './initialState';
import { LineState } from './types';

const lineTokenStateReducer: Reducer<LineState['lineTokenState']> = (
  state = initialState.lineTokenState,
  action
) => {
  switch (action.type) {
    case SUBMIT_LINE_TOKEN:
      return STATE_LOADING;
    case VALIDATE_LINE_TOKEN_SUCCESS:
      return STATE_SUCCESS;
    case VALIDATE_LINE_TOKEN_ERROR:
      return STATE_ERROR;
    case RESET_LINE_TOKEN_STATE:
    case LOGIN_START:
    case getCommonResetAction(action.type):
      return initialState.lineTokenState;
    default:
      return state;
  }
};

const updatedPersistLineButtonReducer: Reducer<LineState['updatedPersistLineButtonState']> = (
  state = false,
  action
) => {
  switch (action.type) {
    case FETCH_PROFILE_SUCCESS:
      if (state) return true;
      if (action.payload?.data?.account?.line_id_linked) {
        localStorage.setItem(PERSIST_LINE_BUTTON, 'true');
        return true;
      }
      return false;
    case getCommonResetAction(action.type):
      return false;
    default:
      return state;
  }
};

export const reducer = combineReducers({
  lineTokenState: lineTokenStateReducer,
  updatedPersistLineButtonState: updatedPersistLineButtonReducer,
});
